import { render, staticRenderFns } from "./PortfolioForm.vue?vue&type=template&id=228d5026&"
import script from "./PortfolioForm.vue?vue&type=script&lang=js&"
export * from "./PortfolioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports